// Elements that own typed input; if one of these has focus, the user is typing into it.
export const isEditableElement = (element: Element | null): boolean => {
  if (!element) return false;
  const tag = element.tagName;
  return (
    tag === 'INPUT' ||
    tag === 'TEXTAREA' ||
    tag === 'SELECT' ||
    (element as HTMLElement).isContentEditable
  );
};
